import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography, Stack, useTheme } from '@mui/material';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import appConfig from '../../../config/appConfig';

const VATReportDesclaimerBanner = () => {
  const { documentReports: dr } = useTranslatedMessages();
  const disclaimer = (dr.vat_report?.disclaimer ?? '').replace(/\{brandName\}/g, appConfig.brandName);

  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255, 249, 237, 1)',
        border: '1px solid rgba(235, 218, 173, 1)',
        borderRadius: '8px',
        px: 1.5,
        py: 1.25,
        mb: 2,
      }}
    >
      <Stack spacing={1} direction="row" alignItems="flex-start">
        <InfoOutlinedIcon sx={{ color: theme.palette.error.dark }} />
        <Typography variant="body2" sx={{ color: theme.palette.error.dark, fontWeight: 600 }}>
          {disclaimer}
        </Typography>
      </Stack>
    </Box>
  );
};

export default VATReportDesclaimerBanner;
